$(document).ready(() => {
    $('.js-product-prev, .js-product-next')
    .on('mouseenter', function(e) {
        $(e.currentTarget)
            .addClass('hover')
            .find('.product-prev__title, .product-next__title')
            .animate({
                'opacity': '1',
                'width': '180px'
            }, 100)
    })
    .on('mouseleave', function(e) {
        $(e.currentTarget)
            .find('.product-prev__title, .product-next__title')
            .animate({
                'opacity': '0',
                'width': '0'
            }, 50, function() {
                $(e.currentTarget).removeClass('hover');
        })
    });
})
